import { z } from "zod";

// ===== ZOD VALIDATION SCHEMAS =====

export const GetHelloQuerySchema = z.object({
  name: z.string().trim().min(1).max(100).optional(),
});

// ===== TYPE DEFINITIONS =====

export type GetHelloQuery = z.infer<typeof GetHelloQuerySchema>;

// API Response type
export interface HelloResponse {
  message: string;
  timestamp: string;
  name?: string;
}

// Error types
export type HelloError =
  | { type: "INVALID_NAME" }
  | { type: "SERVICE_ERROR"; details: string };


